// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"ModalRequestCallback_loadingSpinner__l_Q8N","wrapper":"ModalRequestCallback_wrapper__XYBqD"};